import { TFunction } from 'i18next';
import { CategoryFromAPI } from 'types/category/categoryTypes';
import { GetSuppliersFromAPI, SelectOptions } from 'types/productTypes';

export const convertToProductCategoryOptions = async (
  data: CategoryFromAPI[] | []
): Promise<SelectOptions[]> => {
  if (!data || data.length === 0) {
    return [{ options: [] }];
  }
  return [
    {
      options: data.map((item) => ({
        label: item.name,
        value: item.category_number.toString(),
      })),
    },
  ];
};
export const convertToProductCategoryIdOptions = async (
  data: CategoryFromAPI[] | [],
  t: TFunction | null = null,
  hasBlank = false
): Promise<SelectOptions[]> => {
  if (!data || data.length === 0) {
    return [{ options: [] }];
  }
  const options = data.map((item) => ({
    label: item.name,
    value: item.id.toString(),
  }));

  if (hasBlank && t !== null) {
    // options.unshift({ label: '\u00A0', value: '' });
    options.unshift({ label: t('All Categories'), value: '' });
  }

  return [{ options }];
};

export const convertToSupplierOptions = async (
  data: GetSuppliersFromAPI[] | [],
  t: TFunction | null = null,
  hasBlank = false
): Promise<SelectOptions[]> => {
  if (!data || data.length === 0) {
    return [{ options: [] }];
  }
  const options = data.map((item) => ({
    label: item.company_name,
    value: item.id.toString(),
  }));

  if (hasBlank && t !== null) {
    // options.unshift({ label: '\u00A0', value: '' });
    options.unshift({ label: t('All Suppliers'), value: '' });
  }

  return [{ options }];
};
